<template>
  <div id="projectList">
    <div class="opreationBox">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        label-width="120px"
      >
        <el-form-item label="交易时间">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="formInline.searchTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="">
          <el-button
            style="width:98px"
            type="primary"
            @click="handleCurrentChange(1)"
          >查询</el-button>
          <el-button
            style="width:98px"
            type="danger"
            plain
            @click="reset"
          >重置</el-button>
        </el-form-item>
        <el-form-item
          label=""
          style="float:right"
        >
          <el-button
            @click="exportFn()"
            style="width:98px"
            type="primary"
          >导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox">
      <!-- <el-table
        v-loading="loading"
        :data="quesList"
        :height="tableH"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
      > -->
      <el-table
        v-loading="loading"
        :data="quesList"
        :height="tableH"
        border
        style="width: 100%"
      >
        <!-- <el-table-column
          align="center"
          type="selection"
          width="55"
        >
        </el-table-column> -->
        <el-table-column
          fixed
          header-align="center"
          prop="id"
          label="项目号"
          width="150"
        >
        </el-table-column>
        <el-table-column
          fixed
          header-align="center"
          prop="questionnaireTitle"
          label="问卷标题"
          width="250"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totalPrice"
          label="投放总金额(元)"
          width="180"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="price"
          label="单个红包金额(元)"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="amount"
          label="投放红包个数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="amountOfSend"
          label="已发出的红包数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="amountOfRemain"
          label="剩余红包数量"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="dateOfLaunch"
          label="投放开始时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="dateOfStopLaunch"
          label="投放截止时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receivePrice"
          label="累计费用"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="currentTransferPrice"
          label="发生费用"
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox">
      <!-- <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObj.PageIndex"
        :page-sizes="[2, 4, 10, 20, 50, 100]"
        :page-size="pageObj.PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObj.total"
      >
      </el-pagination> -->
    </div>
  </div>
</template>

<script>
import { getTransferList} from 'api/request'
import axios from 'axios'
import { SetTableH } from '../../utils/utils'
export default {
  data() {
    return {
      loading: true,
      tableH: '250',
      formInline: {
        searchTime:'',
      },
      pageObj: {
        total: 0,
        PageIndex: 1,
        PageSize: 10,
      },
      quesList: [],
    }
  },
  components: {
  },
  methods: {
    handleSizeChange(val) {
      this.pageObj.PageSize = val
      this.getQuesList()
    },
    handleCurrentChange(val) {
      console.log(this.formInline)
      this.pageObj.PageIndex = val
      this.getQuesList()
    },
    exportFn(){
      let params = {
        TransferStartDate: this.formInline.searchTime
          ? this.formInline.searchTime[0]
          : null,
        TransferEndDate: this.formInline.searchTime
          ? this.formInline.searchTime[1]
          : null,
      }
      let time = new Date().getTime()
      let link = `/api/manager/questionnaire/exportTransferData?TransferStartDate=${params.TransferStartDate}&TransferEndDate=${params.TransferEndDate}`
      axios({
        method: 'GET',
        url: link,
        responseType:'blob'
      })
      .then(res => {
        const blob = new Blob([res.data], {
          type: 'application/x-zip-compressed'
        })
        let fileName = '小数答题费用汇总.zip'
        if (!!window.ActiveXObject || 'ActiveXObject' in window) {
          window.navigator.msSaveOrOpenBlob(blob, fileName)
        }
        else {
          const elink = document.createElement('a')
          elink.download = fileName
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        }
      })
      .catch(function(err) {
        console.log(err)
      })
    },
    reset() {
      this.formInline.searchTime = ''
      this.handleCurrentChange(1)
    },
    async getQuesList() {
      let params = {
        PageIndex: this.pageObj.PageIndex,
        PageSize: this.pageObj.PageSize,
        TransferStartDate: this.formInline.searchTime
          ? this.formInline.searchTime[0]
          : null,
        TransferEndDate: this.formInline.searchTime
          ? this.formInline.searchTime[1]
          : null,
      }
      this.loading = true
      let data = await getTransferList(params)
      if (data) {
        this.quesList = data.rows
        this.pageObj.total = data.total
        this.loading = false
      }
    }
  },
  mounted() {
    SetTableH(this)
  },
  created() {
    this.getQuesList()
  },
}
</script>
<style lang='scss'>
#projectList {
  height: 100%;
  width: 100%;
  .formBox {
    width: 200px;
  }
  .pageBox {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
